function getAddressComponent(googlePlace, type, field) {
  if (googlePlace && googlePlace.address_components) {
    let found = googlePlace.address_components.find(
      (address_component) => address_component.types && address_component.types.includes(type)
    );
    return found ? (field ? found[field] : found.long_name) : null;
  }
  return null;
}

export function getCity(googlePlace) {
  return (
    getAddressComponent(googlePlace, 'locality') || getAddressComponent(googlePlace, 'sublocality')
  );
}

export function getState(googlePlace) {
  return (
    getAddressComponent(googlePlace, 'administrative_area_level_1') ||
    getAddressComponent(googlePlace, 'administrative_area_level_2') ||
    getAddressComponent(googlePlace, 'administrative_area_level_3')
  );
}

export function getCountry(googlePlace, field) {
  return getAddressComponent(googlePlace, 'country', field);
}

export function getPostalCode(googlePlace) {
  return getAddressComponent(googlePlace, 'postal_code');
}
export const convertToLatLong = (coords) => coords;
